import React, {Component} from "react"
import {connect} from "react-redux"
import op from "object-path"
import AsyncUserMultiSelect from "../../components/AsyncUserMultiSelect"
import Breadcrumb from "../../components/Breadcrumb"
import IBoxRow from "../../components/IBoxRow"
import PageHeader from "../../components/PageHeader"
import PageBody from "../../components/PageBody"
import {ACTION_ENTERPRISE_ACCOUNT_SHOW_LOADING, ACTION_ENTERPRISE_ACCOUNT_UPDATE_LOADING} from "../../constants"
import Spinner from "../../components/Spinner"
import Alert from "../../components/Alert"
import Form from "../../components/form/Form"
import {Input, Select} from "formsy-react-components"
import {queryEnterpriseAccount, updateEnterpriseAccount} from '../../dispatch'

const REPORT_TYPES = ['A','B','C','D','E','F']

function mapStateToProps(state, ownProps) {

  const user = state.user
  const enterpriseAccount = state.enterpriseAccount
  return {
    user,
    enterpriseAccount
  }
}

const mapDispatchToProps = {
  queryEnterpriseAccount,
  updateEnterpriseAccount
}


class UpdateEnterpriseAccountView extends Component {

  constructor(data) {
    super(data)
    this.state = {
      id: data.params.id,
      disabled: true,
      staff: [],
      user: []
    }
  }

  componentWillMount() {
    this.props.queryEnterpriseAccount(this.state.id)
  }

  componentWillReceiveProps(nextProps) {

    const mapNSort = (it)=>it.map((u)=>({value: u.id, label: u.emailAddress})).sort((a,b)=>a.label.localeCompare(b.label))

    const staff = mapNSort(op.get(nextProps.enterpriseAccount, 'staff', []))
    const user = mapNSort(op.get(nextProps.enterpriseAccount, 'authorizedUsers', []))

    this.setState({staff, user})
  }


  enableSubmitButton = ()=> {
    this.setState({
      disabled: false
    });
  }

  disableSubmitButton = ()=> {
    this.setState({
      disabled: true
    });
  }

  submitForm = (data) => {


    const {name,reportType} = data

    const account = {
      id: this.state.id,
      name,
      staff: this.state.staff.map((u)=>u.value),
      authorizedUsers: this.state.user.map((u)=>u.value)
    }
    if(_.includes(REPORT_TYPES, reportType)) account.preference = {memorie:{reportType}}


    this.props.updateEnterpriseAccount(account)
  }

  render() {

    const name = op.get(this.props.enterpriseAccount, 'name')
    const reportType = op.get(this.props.enterpriseAccount, 'preference.memorie.reportType')
    const loading = op.get(this.props.enterpriseAccount, 'loading', false)
    const error = op.get(this.props.enterpriseAccount, 'error')

    const handleStaffSelectChange = (value) => {
      this.setState({staff: value});
    }

    const handleUserSelectChange = (value) => {
      this.setState({user: value});
    }


    const reportTypeOptions = REPORT_TYPES.map(
      (c)=>
        ({
          value: c,
          label: c
        })
    )

    return (
      <div>
        <PageHeader pageTitle="Enterprise Accounts">
          <Breadcrumb data={[{
            name: 'Admin',
            link: '/admin'
          }, {name: 'Enterprise', link: '/admin/enterprise'}, {name}]}/>
        </PageHeader>

        <PageBody>
          <IBoxRow title="Enterprise Account">
            <Alert show={error} message={error ? error.message : ""}/>
            <Spinner show={loading}/>
            <Form
              onSubmit={this.submitForm}
              onValid={this.enableSubmitButton}
              onInvalid={this.disableSubmitButton}
              validatePristine={false}
              ref="enterpriseAccountForm">

              <div className="form-group">
                <Input
                  name="name"
                  value={name}
                  label="Name"
                  type="text"
                  placeholder="Enterprise Account Name"
                  required
                />
              </div>

              <div className="form-group">
                <Select name="reportType"
                        value={reportType}
                        label="Report Type"
                        options={[{value:'', label:"Default"}, ...reportTypeOptions]}
                />
              </div>


              <div className="form-group" style={{'textAlign': 'left'}}>

                  <div className="form-group row">
                    <label className="control-label col-sm-3">Staff</label>
                    <AsyncUserMultiSelect
                      className="col-sm-9"
                      name="staff"
                      value={this.state.staff}
                      onChange={handleStaffSelectChange}
                    />
                  </div>

              </div>

              <div className="form-group" style={{'textAlign': 'left'}}>

                <div className="form-group row">
                  <label className="control-label col-sm-3">Authorized User</label>
                  <AsyncUserMultiSelect
                    className="col-sm-9"
                    name="user"
                    value={this.state.user}
                    onChange={handleUserSelectChange}
                  />
                </div>

              </div>

              <div className="form-group" style={{'textAlign': 'right'}}>
                <div className="col-sm-4 col-sm-offset-8">
                  <input className="btn btn-primary"
                         formNoValidate={false} type="submit"
                         disabled={this.state.disabled}
                         defaultValue="Save Changes"/>
                </div>
              </div>




            </Form>
          </IBoxRow>
        </PageBody>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpdateEnterpriseAccountView)



// WEBPACK FOOTER //
// ./src/routes/admin/UpdateEnterpriseAccountView.js